import React, { createContext, useContext, useState, useEffect } from 'react';
import * as authApi from '../auth/authApi';

const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // On load, try to restore the session from the stored refresh token.
  useEffect(() => {
    let active = true;
    (async () => {
      if (await authApi.refresh()) {
        const u = await authApi.me();
        if (active) setUser(u);
      }
      if (active) setLoading(false);
    })();
    return () => { active = false; };
  }, []);

  const value = {
    user,
    loading,
    login: async (email, password) => { const u = await authApi.login(email, password); setUser(u); return u; },
    register: async (payload) => { const u = await authApi.register(payload); setUser(u); return u; },
    // Re-fetch the current user (e.g. after a membership purchase changes entitlement/org).
    refreshUser: async () => { const u = await authApi.me(); setUser(u); return u; },
    logout: async () => { await authApi.logout(); setUser(null); },
    deleteAccount: async () => { const ok = await authApi.deleteAccount(); setUser(null); return ok; },
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
